import React, { useState } from 'react';

import validateFormData from '../../validation/validateFormData';
import { CHECK_ID, VERIFY_NIN } from '../../utils/constants';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';

import styles from './PersonalDetails.module.scss';

const PersonalDetails = ({ setStatus, agentData, dispatch, state = {} }) => {
    const [validationErrors, setValidationErrors] = useState({ errors: true });
    const [loading, setLoading] = useState(false);

    const { addToast } = useToasts();

    const handleOnChange = ({ target }) => {
        setValidationErrors({ ...validationErrors, [target.name]: '' });

        dispatch({
            type: 'SET_AGENT_DATA',
            payload: { [target.name]: target.value },
        });
    };

    const handleProceed = (e) => {
        e.preventDefault();
        setLoading(true);

        let checkIdApi = CHECK_ID;
        let payload;

        const {
            first_name,
            last_name,
            date_of_birth,
            email,
            gender,
            business_phone,
            nin,
            bvn,
        } = agentData;

        const state = {
            first_name,
            last_name,
            date_of_birth,
            email,
            gender,
            business_phone,
            nin,
            bvn,
        };

        const keys = Object.keys(state);
        const errors = validateFormData(agentData, keys);

        setValidationErrors(errors);

        if (Object.keys(errors).length > 0) return;

        checkIdApi = VERIFY_NIN;
        payload = {
            number: agentData.nin,
            first_name: agentData.first_name,
            surname: agentData.last_name,
            middle_name: '',
            dob: agentData.date_of_birth,
            gender: agentData.gender,
        };

        (async function checkID() {
            try {
                const res = await axios.post(checkIdApi, payload);
                if(res.data.status == 'Successful' )
                {
                    let message = 'Your ID has been verified'
                    addToast(
                        res.data.message ?? message,
                        {
                        appearance: 'success',
                        autoDismiss: true,
                        }
                    );
                    setLoading(false);
                    setStatus('business');
                }else {
                    let message = 'We cannot verify your Identity. Try again'
                    addToast(
                        res.data.message ?? message,
                        {
                        appearance: 'error',
                        autoDismiss: true,
                        }
                    );
                    setLoading(false);
                }
            } catch (e) {
                console.log(e);
                let message = 'We cannot verify your Identity. Try Again'
                addToast(
                    message,
                        {
                        appearance: 'error',
                        autoDismiss: true,
                        }
                    );
                setLoading(false);
            }
        })();

    };

    return (
        <div className={styles.container}>
            <form className={styles.form} onSubmit={handleProceed}>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='firstname'>
                        First Name
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='first_name'
                        onChange={handleOnChange}
                        value={agentData.first_name}
                    />
                    {validationErrors.first_name && (
                        <p className={styles.errorText}>
                            {validationErrors.first_name.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='last_name'>
                        Last Name
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='last_name'
                        onChange={handleOnChange}
                        value={agentData.last_name}
                    />
                    {validationErrors.last_name && (
                        <p className={styles.errorText}>
                            {validationErrors.last_name.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='date_of_birth'>
                        Date of Birth
                    </label>
                    <input
                        className={styles.input}
                        type='date'
                        name='date_of_birth'
                        onChange={handleOnChange}
                        value={agentData.date_of_birth}
                    />
                    {validationErrors.date_of_birth && (
                        <p className={styles.errorText}>
                            {validationErrors.date_of_birth.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='email'>
                        Email
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='email'
                        onChange={handleOnChange}
                        value={agentData.email}
                    />
                    {validationErrors.email && (
                        <p className={styles.errorText}>
                            {validationErrors.email.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='gender'>
                        Gender
                    </label>
                    <select
                        className={styles.input}
                        type='text'
                        name='gender'
                        onChange={handleOnChange}
                        value={agentData.gender}
                    >
                        <option value=''>Select Gender</option>
                        {state.gender &&
                            state.gender.map(({ key, value }) => {
                                return (
                                    <option value={key} key={key}>
                                        {value}
                                    </option>
                                );
                            })}
                    </select>
                    {validationErrors.gender && (
                        <p className={styles.errorText}>
                            {validationErrors.gender.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='business_phone'>
                        Phone
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='business_phone'
                        onChange={handleOnChange}
                        value={agentData.business_phone}
                    />
                    {validationErrors.business_phone && (
                        <p className={styles.errorText}>
                            {validationErrors.business_phone.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='nin'>
                        NIN
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='nin'
                        onChange={handleOnChange}
                        value={agentData.nin}
                    />
                    {validationErrors.nin && (
                        <p className={styles.errorText}>
                            {validationErrors.nin.text}
                        </p>
                    )}
                </div>
                <div className={styles.formGroup}>
                    <label className={styles.label} htmlFor='bvn'>
                        BVN
                    </label>
                    <input
                        className={styles.input}
                        type='text'
                        name='bvn'
                        onChange={handleOnChange}
                        value={agentData.bvn}
                    />
                    {validationErrors.bvn && (
                        <p className={styles.errorText}>
                            {validationErrors.bvn.text}
                        </p>
                    )}
                </div>
                <div className={`${styles.submit} ${styles.formGroup}`}>
                    <button className={styles.button} type='submit' disabled={loading}>
                        {loading ? 'Loading...' : 'Next'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PersonalDetails;
